exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".default-grid-size {\n  width: 100% !important;\n  height: 70vh !important;\n  font-size: 12px !important;\n}\n\n.segments-grid-delete-button {\n  font-size: 12px !important;\n}\n\n.segments-grid-header {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.segments-grid-api-call-alert {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n}\n\n.add-segment-modal .col {\n  padding-left: .25rem !important;\n  padding-right: .25rem !important;\n}", ""]);

// exports
